import { OrthoApprovalStatus } from "api/model";

/**
 * A stitched orthomosaic exists and can be reviewed or shown on the map.
 * `uploading` is still receiving images. `processing` means creation was
 * requested and the image is not ready yet.
 */
export const isStitchedOrthoStatus = (
  status: OrthoApprovalStatus,
): status is
  | typeof OrthoApprovalStatus.approved
  | typeof OrthoApprovalStatus.pending
  | typeof OrthoApprovalStatus.rejected =>
  status === OrthoApprovalStatus.approved ||
  status === OrthoApprovalStatus.pending ||
  status === OrthoApprovalStatus.rejected;
